/**
 * Planning Center sign-in helpers. The backend's start/callback round trip doesn't carry the
 * portal path the person was heading to (usually /p/{code}), so it is kept in sessionStorage (and
 * localStorage as a fallback for phones that open the callback in a new tab) for the callback page.
 * The callback URL must be in UserManagement's PlanningCentreLogin:AllowedRedirectUris AND in the
 * Planning Center OAuth app's redirect URIs.
 */
const REDIRECT_KEY = 'procedures.pco.redirect';

export const PLANNING_CENTRE_CALLBACK_PATH = '/auth/oauth/planning-centre/callback';

export function planningCentreCallbackUrl(): string {
  return `${window.location.origin}${PLANNING_CENTRE_CALLBACK_PATH}`;
}

/** Only same-app absolute paths are honoured (no open redirects). */
export function safeRedirect(path: string | null | undefined, fallback = '/'): string {
  return path && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/auth/') ? path : fallback;
}

export function rememberPlanningCentreRedirect(path: string): void {
  const value = safeRedirect(path);
  try {
    sessionStorage.setItem(REDIRECT_KEY, value);
  } catch {
    /* private mode */
  }
  try {
    localStorage.setItem(REDIRECT_KEY, value);
  } catch {
    /* blocked storage: the callback falls back to the directory */
  }
}

export function takePlanningCentreRedirect(): string {
  let v: string | null = null;
  try {
    v = sessionStorage.getItem(REDIRECT_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
  } catch {
    /* ignore */
  }
  try {
    if (!v) v = localStorage.getItem(REDIRECT_KEY);
    localStorage.removeItem(REDIRECT_KEY);
  } catch {
    /* ignore */
  }
  return safeRedirect(v);
}
